import { getLocalAccessToken } from "../service";

export const isLogin = () => getLocalAccessToken() !== null;
